import { render, staticRenderFns } from "./FlowDialog.vue?vue&type=template&id=2fdf08de&"
import script from "./FlowDialog.vue?vue&type=script&lang=js&"
export * from "./FlowDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports